import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { ActionTypeEnum, OptionsType, SELECT_ALL_ID, SELECT_ALL_LABEL, ValueType } from '../../constants';
import ControlledMultiSelect from './ControlledMultiSelect';

const generateSelectAllOption = option => {
  const selectAllOption = {};

  Object.keys(option).forEach(key => {
    if (typeof key === 'string' && key.toLowerCase() === 'id') {
      selectAllOption[key] = SELECT_ALL_ID;
      return;
    }
    selectAllOption[key] = SELECT_ALL_LABEL;
  });

  if (!selectAllOption.id) {
    selectAllOption.id = SELECT_ALL_ID;
  }

  return selectAllOption;
};

/**
 * @internal
 */
const SelectAll = ({ ...props }) => {
  const selectAllOption = generateSelectAllOption(props.options[0]);
  const optionsWithSelectAll = [selectAllOption, ...props.options];
  const [options, setOptions] = useState(optionsWithSelectAll);
  const [value, setValue] = useState(props.value);

  // Reset options and value states when the underlying props change.
  useEffect(() => {
    setOptions([generateSelectAllOption(props.options[0]), ...props.options]);
    setValue(props.value);
  }, [props.value, props.options]);

  const handleOnChangeCallback = (values, meta) => {
    if (props.onChange) {
      props.onChange(values, meta);
    }
  };

  const handleChange = (values, meta = {}) => {
    if (meta.action === ActionTypeEnum.CLEAR || meta.action === ActionTypeEnum.REMOVE_VALUE) {
      setOptions(optionsWithSelectAll);
      setValue(values);
      handleOnChangeCallback(values, meta);
    }

    if (
      (meta.action === ActionTypeEnum.SELECT_OPTION && meta.option.id === selectAllOption.id) ||
      (values && values.length === props.options.length)
    ) {
      setOptions(props.options);
      setValue(props.options);
      handleOnChangeCallback(props.options, meta);
    } else {
      setValue(values);
      handleOnChangeCallback(values, meta);
    }
  };

  return <ControlledMultiSelect {...props} onChange={handleChange} options={options} value={value} />;
};

SelectAll.propTypes = {
  onChange: PropTypes.func,
  options: OptionsType,
  value: ValueType,
};

/**
 * @internal
 */
export default SelectAll;
